import { render, staticRenderFns } from "./DeathData.vue?vue&type=template&id=7fd25d70&"
import script from "./DeathData.vue?vue&type=script&lang=js&"
export * from "./DeathData.vue?vue&type=script&lang=js&"
import style0 from "./DeathData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../bigTravel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports